(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["carousel"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    new Swiper('.product-carousel', {
      slidesPerView: 1,
      spaceBetween: 16,
      loop: true,
      navigation: { nextEl: '.next-slide', prevEl: '.prev-slide' },
      breakpoints: {
        640: {
          slidesPerView: 2,
        },
        768: { slidesPerView: 3 },
        1024: { slidesPerView: 4 },
      },
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const filtersButton = document.getElementById('CollectionFiltersButton');
    const filtersForm = document.getElementById('CollectionFiltersForm');
    const filterBlur = document.querySelector('.filter-blur');

    filtersButton.addEventListener('click', function () {
      filtersForm.classList.add('active');
      filterBlur.classList.add('active');
    });

    filterBlur.addEventListener('click', function () {
      filtersForm.classList.remove('active');
      filterBlur.classList.remove('active');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    let lastScrollY = window.scrollY;
    const header = document.querySelector('#PageHeader');
    let ticking = false;

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          if (window.scrollY > lastScrollY && window.scrollY > 100) {
            // Scrolling down
            header.style.transform = 'translateY(-120%)';
          } else {
            // Scrolling up
            header.style.transform = 'translateY(0)';
          }

          // Add or remove "opaque" class based on scroll position
          if (window.scrollY > 200) {
            header.classList.add('opaque');
          } else {
            header.classList.remove('opaque');
          }

          lastScrollY = window.scrollY;
          ticking = false;
        });
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll);
  });

  } catch(e) { console.error(e); }
})();
})();
